import { render } from "./index.vue?vue&type=template&id=69288bc7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=69288bc7&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-testimonial/slider-standard/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__